// extracted by mini-css-extract-plugin
module.exports =  {"counter":"nvgDf7yWMu8hw3SlQDTE","sample":"sSR9pQUCm28zuzxizkCQ","warning":"Wq_VKxQW_dVn2tieXvC0","sampleEmpty":"jJlhpSVjxAW86txQPzYg","actions":"CdHqQVpRhPEYQq84JVnG"};